import { Box, Tooltip, Typography, styled } from "@mui/material";

import CopyToClipboard from "components/CopyToClipboard";

export function TxId({ data }) {
  return (
    <>
      {data?.txId || data?.description2 ? (
        <BoxTexId>
          <Tooltip placement="bottom" title={data?.txId}>
            <Typography variant="subtitle1" color="text.secondary" pr={1}>
              {data?.txId || data?.description2}
            </Typography>
          </Tooltip>

          <CopyToClipboard value={data?.txId || data?.description2} />
        </BoxTexId>
      ) : (
        " - "
      )}
    </>
  );
}

const BoxTexId = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

export default TxId;
